const template=`
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax">
    <widget-status></widget-status>
    <div>
      <h3 class="widgetNoResultsLabel translate" ng-show="noContent &amp;&amp; !widgetIsLoading &amp;&amp; !showTable">No results</h3>
    </div>
    <bubble-d3 class="bubble" data="chartData" chart-type="graphType" selected="selectedNodes" drill="drill(id)" maximized="isMaximized" data-ng-hide="widgetIsLoading || serviceError || noContent || notConfigured || showTable" is-report="isReport" export-type="exportType"></bubble-d3>
    <chart-data-table ng-show="showTable &amp;&amp; !widgetIsLoading" table-data="tableSettings.data" row-title="tableSettings.rowTitle" summary-title="tableSettings.summaryTitle" display-field="tableSettings.displayField" title-field="tableSettings.titleField" summary="tableSettings.summary" drilldown="tableSettings.drilldown" tooltip="tableSettings.tooltip" sort-on-field="tableSettings.sortOnField"></chart-data-table>
  </div>
</div>`;
export default template;
